import {
  DocumentOrganizationKeys,
  FilterOptionKeys,
  GoalFilterDocument,
} from '@griply/types';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { GoalSortingMode, GroupByMode } from 'shared/types/sorting-mode';

export const getGoalFilterDocument = (
  goal: Goal | undefined,
  subGoalIds: ID[],
): GoalFilterDocument => {
  const base = goal?.goalFilterDocument ?? {
    [DocumentOrganizationKeys.GroupByMode]: GroupByMode.None,
  };

  return {
    ...base,
    [DocumentOrganizationKeys.GroupByMode]:
      base.groupByMode ?? GroupByMode.None,
    [DocumentOrganizationKeys.SortingMode]:
      base.sortingMode ?? goal?.goalSortingMode ?? GoalSortingMode.StartDate,
    [DocumentOrganizationKeys.Filters]: {
      ...(base[DocumentOrganizationKeys.Filters] ?? {}),
      [FilterOptionKeys.Goal]: {
        include: [...subGoalIds],
      },
    },
    [DocumentOrganizationKeys.CollapsedSections]:
      base[DocumentOrganizationKeys.CollapsedSections] ??
      goal?.collapsedSubGoals ??
      subGoalIds,
  };
};
